import { useEffect, useState } from "react";
import { getImageFromDB, storeImageInDB } from "../../../utils/indexdb.utils";
import ResultsTable from "../../PegaMas/ResultsTable/ResultsTable";
import Header from "../DrawHeader/DrawHeader";
import ResultsTableHowTo from "../ResultsTableHowTo/ResultsTableHowTo";

interface CountdownTimerProps {
  timeInMilliseconds?: number;
  jackpot: number;
  isResult: boolean;
}

const BACKGROUND_KEY = "background-image";
const BACKGROUND_URL = "https://lotteryblob.blob.core.windows.net/lottery-files/back_new.png";

export default function PegaMasResults({
  timeInMilliseconds,
  jackpot = 0,
  isResult = true,
}: CountdownTimerProps) {
  const [backgroundSrc, setBackgroundSrc] = useState<string | null>(null);

  useEffect(() => {
    const fetchAndCacheBackground = async () => {
      try {
        const cachedImage = await getImageFromDB(BACKGROUND_KEY);

        if (cachedImage) {
          setBackgroundSrc(URL.createObjectURL(cachedImage));
        } else {
          const response = await fetch(BACKGROUND_URL);
          const blob = await response.blob();

          await storeImageInDB(BACKGROUND_KEY, blob);
          setBackgroundSrc(URL.createObjectURL(blob));
        }
      } catch (error) {
        console.error("Error al cargar la imagen de fondo:", error);
        setBackgroundSrc(BACKGROUND_URL);
      }
    };

    fetchAndCacheBackground();
  }, []);

  return (
    <div
      className="results-container"
      style={{
        backgroundImage: backgroundSrc ? `url(${backgroundSrc})` : "none",
      }}
    >
      <Header timeInMilliseconds={timeInMilliseconds} jackpot={jackpot} />
      <div className="results-table-container">
        {isResult && (
          <ResultsTable />
        )}
        {!isResult && (
          <ResultsTableHowTo />
        )}
      </div>
    </div>
  );
}
